import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  wrapper: {
    overflowY: 'auto',
    height: 'calc(100% - 112px)',
    width: '100%',
    display: 'flex',
  },
  content: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
  },
});

export default styles;
